import { z } from 'zod';
import { hvacStateSchema, powertrainTypeSchema, routeTypeSchema, seasonSchema, testTypeSchema, timeBandSchema, trafficLevelSchema, } from '../../common/schemas/enum.schemas.js';
import { uuidSchema } from '../../common/schemas/id.schemas.js';
/**
 * Counters for the dashboard. The run-related fields exist from Phase 1 and simply report zero until
 * `test_runs` lands in Phase 2, so the dashboard layout never has to change.
 */
export const dashboardStatsSchema = z.object({
    vehicles: z.object({
        active: z.number().int().min(0),
        archived: z.number().int().min(0),
    }),
    scenarios: z.object({
        total: z.number().int().min(0),
        core: z.number().int().min(0),
        active: z.number().int().min(0),
    }),
    routes: z.object({
        active: z.number().int().min(0),
        superseded: z.number().int().min(0),
    }),
    segments: z.object({
        active: z.number().int().min(0),
    }),
    protocols: z.object({
        active: z.number().int().min(0),
    }),
    runs: z.object({
        total: z.number().int().min(0),
        drafts: z.number().int().min(0),
        valid: z.number().int().min(0),
        validWithWarning: z.number().int().min(0),
        invalid: z.number().int().min(0),
    }),
});
/**
 * A coverage cell's verdict (plan §7): `✓` valid / `!` valid-with-warning / `×` invalid / `—` not
 * tested. Drafts and submitted-but-unjudged runs leave a scenario NOT_TESTED — coverage means proven.
 */
export const coverageStatusSchema = z.enum(['NOT_TESTED', 'VALID', 'VALID_WITH_WARNING', 'INVALID']);
export const coverageCellSchema = z.object({
    scenarioId: uuidSchema,
    scenarioCode: z.string().min(1),
    testType: testTypeSchema,
    season: seasonSchema,
    timeBand: timeBandSchema,
    hvacState: hvacStateSchema,
    routeType: routeTypeSchema.nullable(),
    idleDurationMin: z.number().int().nullable(),
    /** The traffic the scenario expects, `null` when it prescribes none. */
    trafficLevel: trafficLevelSchema.nullable(),
    isCore: z.boolean(),
    status: coverageStatusSchema,
    validRunCount: z.number().int().min(0),
    totalRunCount: z.number().int().min(0),
    /** Lowest and mean measured figure across the valid runs; `null` while the scenario is untested. */
    bestResult: z.number().nullable(),
    meanResult: z.number().nullable(),
    unit: z.string().min(1),
});
export const coverageMatrixSchema = z.object({
    vehicle: z.object({
        id: uuidSchema,
        code: z.string().min(1),
        label: z.string().min(1),
        powertrainType: powertrainTypeSchema,
    }),
    cells: z.array(coverageCellSchema),
});
export const coverageMatrixInputSchema = z.object({
    vehicleId: uuidSchema,
});
//# sourceMappingURL=benchmarks.schemas.js.map